import { NgModule } from "@angular/core";
import { CommonEnergyMonitor } from "./energy/energy";

@NgModule({
    imports: [
        CommonEnergyMonitor,
    ],
    exports: [
        CommonEnergyMonitor,
    ],
})
export class Common { }
